import { useDatasetValidationCheck } from "hooks/useDatasetValidationCheck";
import { createContext, useContext } from "react";
export const DatasetValidationContext = createContext();

export const DatasetValidationProvider = ({ children }) => {
  const hookData = useDatasetValidationCheck();

  return <DatasetValidationContext.Provider value={hookData}>{children}</DatasetValidationContext.Provider>;
};

export const useDatasetValidationContext = () => {
  const context = useContext(DatasetValidationContext);

  if (context === undefined) {
    throw new Error("useDatasetValidation must be used within a DatasetValidationProvider");
  }
  return context;
};
